import { barcodeLabelTemplateSchema } from "@redotech/redo-model/inventory/barcode-label-builder/barcode-label-definition";
import * as z from "zod/v4";

export const getBarcodeLabelTemplates = {
  name: "getBarcodeLabelTemplates" as const,
  input: z.object({}),
  output: z.object({ templates: z.array(barcodeLabelTemplateSchema) }),
};
